import React, { Component } from "react";
import axios from "axios";
import { dateFormat } from "../../utils/date";
import { serviceUrl } from "../../common/config";
import { withRouterProps } from "../../common/hocs";

let disable = true;
class KycDetail extends Component {
  constructor(props) {
    super(props);
    this.confirmKycStatus = this.confirmKycStatus.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onClick = this.onClick.bind(this);
  }
  state = {
    data: "",
    kycStatus: [],
    confirmStatus: "",
    comment: "",
    show: false,
    completed: false,
    allowEdit: false,
  };
  getKycDetails() {
    axios({
      method: "post",
      responseType: "json",
      url: "/admin/getKycDetails/" + this.props.router.params.formId,
    })
      .then((response) => {
        this.setState({
          data: response.data,
        });
      })
      .catch((err) => {});
  }
  getKycStatusConfirm() {
    axios({
      method: "post",
      responseType: "json",
      url: "/admin/getKycStatusConfirm",
    })
      .then((response) => {
        this.setState({
          kycStatus: response.data,
        });
      })
      .catch((err) => {});
  }
  confirmKycStatus(e) {
    this.setState({
      confirmStatus: e.target.value,
      show: true,
      comment: "",
    });
  }
  onChange(e) {
    this.setState({
      comment: e.target.value,
    });
  }
  onSubmit(userId) {
    let { confirmStatus, comment } = this.state;
    axios({
      method: "post",
      responseType: "json",
      url: "/admin/decisionOnKycs",
      data: {
        formId: this.props.router.params.formId,
        status: confirmStatus,
        comment: comment,
        userId: userId,
      },
    })
      .then((response) => {
        this.setState(
          {
            show: false,
            comment: "",
            completed: true,
          },
          this.getKycDetails()
        );
      })
      .catch((err) => {});
  }
  disableButton() {
    let { confirmStatus, comment } = this.state;
    if (!confirmStatus || !comment) {
      disable = true;
    } else {
      disable = false;
    }
  }
  onClick(userId, e) {
    axios({
      method: "post",
      responseType: "json",
      url: "/admin/AllowEditByAdmin",
      data: {
        formId: this.props.router.params.formId,
        userId: userId,
        AllowEditByAdmin: "true",
      },
    })
      .then((response) => {
        this.setState({
          allowEdit: true,
          completed: false,
        });
        this.getKycDetails();
      })
      .catch((err) => {});
  }
  componentDidMount() {
    this.getKycDetails();
    this.getKycStatusConfirm();
  }
  render() {
    let {
      data,
      kycStatus,
      confirmStatus,
      show,
      comment,
      completed,
      allowEdit,
    } = this.state;
    let placeholder = "";
    let date;
    this.disableButton();
    if (data && data.updatedAt) {
      date = dateFormat(data.updatedAt);
    }
    if (confirmStatus === "Approved") {
      placeholder = "Enter COA code";
    }
    if (confirmStatus === "Rejected") {
      placeholder = "Enter Reject Reason";
    }
    return (
      <React.Fragment>
        <div className="container">
          <div className="row">
            <div>&nbsp;</div>
            <div className="col-md-12">
              <h4>KYC Details</h4>
              <div>&nbsp;</div>
              {data ? (
                <div className="form-control" key="div">
                  <label>First Name :</label>&nbsp;
                  <label>{data.firstName}</label>
                  <br />
                  <label>Last Name :</label>&nbsp;
                  <label>{data.lastName}</label>
                  <br />
                  <label>Aadhaar Number :</label>&nbsp;
                  <label>{data.AdharNo}</label>
                  <br />
                  <label>PAN :</label>&nbsp;
                  <label>{data.PanNo}</label>
                  <br />
                  <label>GSTIN :</label>&nbsp;
                  <label>{data.GSTNO}</label>
                  <br />
                  <label>Status :</label>&nbsp;
                  <label>{data.Status}</label>
                  <br />
                  <label>Attachment :</label>&nbsp;
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={serviceUrl + "kyc/downloadAllFile/" + data.userId}
                  >
                    &nbsp; <i className="icon-arrow-down-circle"></i>{" "}
                  </a>
                  <br />
                  <label>Files :</label>&nbsp;
                  {data.kycFiles && data.kycFiles.length > -1
                    ? data.kycFiles.map((f) => (
                        <span key={f.fileName}>
                          {f.fileName}{" "}
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={
                              serviceUrl +
                              "kyc/downloadFile/" +
                              data.userId +
                              "/" +
                              f.fileName
                            }
                          >
                            &nbsp; <i className="icon-arrow-down-circle"></i>{" "}
                          </a>
                          &nbsp;
                        </span>
                      ))
                    : null}
                  <br />
                  {localStorage["role"] === "2" ? (
                    <React.Fragment>
                      <label>Allow Editing :</label>&nbsp;
                      <input
                        type="radio"
                        checked={
                          data.AllowEditByAdmin === "true" ? true : false
                        }
                        onClick={this.onClick.bind(this, data.userId)}
                      />
                      {allowEdit ? (
                        <span> Editing has been allowed to the user</span>
                      ) : null}
                      <br />
                    </React.Fragment>
                  ) : null}
                  {data.Status === "Pending" ? (
                    <label>Submitted on : {date}</label>
                  ) : null}
                  {data.Status === "Approved" ? (
                    <React.Fragment>
                      <label>Approved on : {date}</label>
                      <br />
                      <label>COA Code : {data.Comment}</label>
                    </React.Fragment>
                  ) : null}
                  {data.Status === "Rejected" ? (
                    <React.Fragment>
                      <label>Rejected on : {date}</label>
                      <br />
                      <label>Rejection Reason : {data.Comment}</label>
                    </React.Fragment>
                  ) : null}
                  {data.Status === "Pending" ? (
                    <div>
                      <label>Decision :</label>&nbsp;
                      {kycStatus && kycStatus.length > -1
                        ? kycStatus.map((s) => (
                            <span key={s.status}>
                              {" "}
                              <input
                                type="radio"
                                name="radio"
                                key={s.status}
                                value={s.status}
                                onClick={this.confirmKycStatus}
                              />{" "}
                              {s.statusConfirm}{" "}
                            </span>
                          ))
                        : null}
                      {show ? (
                        <div>
                          <textarea
                            placeholder={placeholder}
                            onChange={this.onChange}
                            value={comment || ""}
                          />
                        </div>
                      ) : null}
                      <div>
                        <button
                          className="btn btn-primary"
                          onClick={this.onSubmit.bind(this, data.userId)}
                          disabled={disable}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
              {completed ? <div>Successfully {data.Status}</div> : null}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

// Custom HOC to inject router props to use React Router v6 hooks in class components
export default withRouterProps(KycDetail);